import { Profile } from "../../models/profile";

export interface ProfileState {

    profile ?: Profile


}

export const initialProfileState: ProfileState = {

    profile: undefined,


};
